/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { GetPendingAppointmentsApiResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPendingAppointments: build.query<GetPendingAppointmentsApiResponse, void>({
      query: () => ({ method: 'GET', url: `/v1/appointments/pending` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getPendingAppointmentsApi };
export const { useGetPendingAppointmentsQuery, useLazyGetPendingAppointmentsQuery } = injectedRtkApi;
